import { render, staticRenderFns } from "./RuleImportFromTemplate.vue?vue&type=template&id=ec2daa90&scoped=true"
import script from "./RuleImportFromTemplate.vue?vue&type=script&lang=js"
export * from "./RuleImportFromTemplate.vue?vue&type=script&lang=js"
import style0 from "./RuleImportFromTemplate.vue?vue&type=style&index=0&id=ec2daa90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2daa90",
  null
  
)

export default component.exports